import { setupHoldingSyncFromTransactionsListener } from 'app-components/store/listeners';

import { startAppListening } from './listenerMiddleware';

setupHoldingSyncFromTransactionsListener(startAppListening);
